// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowRightWhite: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="currentColor">
            <polygon
                fill="#FFF"
                points="834.4 1378 833 1379.375 837.2 1383.5 833 1387.625 834.4 1389 840 1383.5"
                transform="translate(-833 -1378)"
            />
        </svg>
    );
};

export default React.memo(IconArrowRightWhite);
